import { ScoreBy } from "types";

export const scoreByMap: Record<string, ScoreBy> = {
  total: "TOTAL",
  forecastedTotal: "TOTAL",
  wilks: "BODY_WEIGHT_POINTS",
  forecastedWilks: "BODY_WEIGHT_POINTS",
  wilksAge: "BODY_WEIGHT_AND_AGE_POINTS",
  forecastedWilksAge: "BODY_WEIGHT_AND_AGE_POINTS",
  wilks2020: "WILKS_2020_POINTS",
  forecastedWilks2020: "WILKS_2020_POINTS",
  wilks2020Age: "WILKS_2020_AND_AGE_POINTS",
  forecastedWilks2020Age: "WILKS_2020_AND_AGE_POINTS",
  ipfPoints: "IPF_POINTS",
  forecastedIpfPoints: "IPF_POINTS",
  ipfAgePoints: "IPF_AND_AGE_POINTS",
  forecastedIpfAgePoints: "IPF_AND_AGE_POINTS",
  dotsPoints: "DOTS_POINTS",
  forecastedDotsPoints: "DOTS_POINTS",
  dotsAgePoints: "DOTS_AND_AGE_POINTS",
  forecastedDotsAgePoints: "DOTS_AND_AGE_POINTS",
  schwartzMalonePoints: "SCHWARTZ_MALONE",
  schwartzMaloneAndAgePoints: "SCHWARTZ_MALONE_AND_AGE_POINTS",
  glossbrennerPoints: "GLOSSBRENNER_POINTS",
  glossbrennerAndAgePoints: "GLOSSBRENNER_AND_AGE_POINTS",
  reshelPoints: "RESHEL_POINTS",
  reshelPointsAndAgePoints: "RESHEL_POINTS_AND_AGE_POINTS",
  paraDotsPoints: "PARA_DOTS_POINTS",
  forecastedParaDotsPoints: "PARA_DOTS_POINTS",
  percentOfRecord: "PERCENT_OF_RECORD",
  forecastedPercentOfRecord: "PERCENT_OF_RECORD",
  kPoints: "K_POINTS",
  zScore: "ZSCORE_POINTS",
  forecastedZscore: "ZSCORE_POINTS",
  zScoreAgePoints: "ZSCORE_AND_AGE_POINTS",
  forecastedZscoreAgePoints: "ZSCORE_AND_AGE_POINTS",
};
